/**
 * O motivo terminal do pedido de Terraform (consoleai#24981): a conclusão
 * primeiro, uma linha por frase do servidor; o erro bruto do terraform (o
 * trecho depois de ". Erro: ", itens separados por "; ") recolhido em "Ver
 * erro completo", um por linha. Antes o motivo inteiro era um parágrafo só —
 * no pedido #37 (prd, 14/10/2026), 3833 caracteres de erro da AWS repetido
 * segredo a segredo, e a frase que dizia o que fazer ficava no fim, quando
 * existia.
 *
 * Texto em Barlow (fonte do tema); só o trecho entre crases (nome de
 * segredo, tag, HCL) e as linhas do erro bruto vão em JetBrains Mono, via
 * `Dado` — docs/DESIGN_SYSTEM.md §3 reserva a mono para dado. Alinhado à
 * esquerda.
 */
import { useState } from 'react'
import { Button, Collapse, ScrollArea, Stack, Text } from '@mantine/core'
import { Dado } from './Dado'

const MARCA_DO_ERRO = '. Erro: '

export interface MotivoSeparado {
  linhas: string[]
  erros: string[]
}

export function separarMotivo(texto: string): MotivoSeparado {
  const i = texto.indexOf(MARCA_DO_ERRO)
  const conclusao = i >= 0 ? `${texto.slice(0, i)}.` : texto
  const erros = i >= 0
    ? texto.slice(i + MARCA_DO_ERRO.length).split('; ').map((e) => e.trim()).filter(Boolean)
    : []
  return { linhas: conclusao.split('\n').map((l) => l.trim()).filter(Boolean), erros }
}

/** Frase com trechos entre crases: os trechos viram `Dado`. */
function ComDados({ frase }: { frase: string }) {
  const partes = frase.split('`')
  return (
    <>
      {partes.map((p, i) => (i % 2 === 1 ? <Dado key={i}>{p}</Dado> : <span key={i}>{p}</span>))}
    </>
  )
}

export function MotivoDoPedido({ texto, dimmed = false }: { texto: string; dimmed?: boolean }) {
  const [aberto, setAberto] = useState(false)
  const { linhas, erros } = separarMotivo(texto)
  return (
    <Stack gap={4} align="flex-start">
      {linhas.map((linha, i) => (
        <Text key={i} size={linha.startsWith('Guia:') ? 'xs' : 'sm'}
              c={dimmed || linha.startsWith('Guia:') ? 'dimmed' : undefined}
              fw={i === 0 ? 500 : undefined}>
          <ComDados frase={linha} />
        </Text>
      ))}
      {erros.length > 0 && (
        <>
          <Button size="xs" variant="subtle" color="inovareTeal" px={0}
                  onClick={() => setAberto((a) => !a)}>
            {aberto ? 'Esconder erro' : 'Ver erro completo'}
          </Button>
          <Collapse in={aberto} style={{ width: '100%' }}>
            <ScrollArea.Autosize mah={220} style={{ width: '100%' }}>
              <Stack gap={2} align="flex-start">
                {erros.map((erro, i) => (
                  <div key={i}><Dado>{erro}</Dado></div>
                ))}
              </Stack>
            </ScrollArea.Autosize>
          </Collapse>
        </>
      )}
    </Stack>
  )
}
